import http from "../http-common";

class SupplierDataService {
  getAll() {
    return http.get("/suppliers");
  }

  getSupplierByDescr(condition, sortfield,sorttype) {
    return http.get(`/suppliers/search/?suppliername=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/suppliers/${id}`);
  }

  create(data) {
    return http.post("/suppliers/newsupplier", data);
  }

  update(id, data) {
    return http.put(`/suppliers/${id}`, data);
  }

  delete(id) {
    return http.delete(`/suppliers/${id}`);
  }

  deleteAll() {
    return http.delete(`/suppliers`);
  }

  findById(id) {
    return http.get(`/suppliers?id=${id}`);
  }
}

export default new SupplierDataService();